import { useState, useEffect } from "react";
import FactorTable from "../components/order/FactorTable";
import { addCommas } from "@persian-tools/persian-tools";
import useAxios from "../services/useAxios";
import { useParams } from "react-router-dom";
import { TimeStampToJalali } from "../utils/helperFunction";

export default function Factor() {
  let { orderId } = useParams();
  const [factorList, setFactorList] = useState({});
  const { loading, execute } = useAxios("api2/orders_list");
  const { execute: executeFabric } = useAxios("api/Find_Fabrics");
  const [fabricList, setFabricList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const addCount = (number) => {
    let temp = totalCount;
    temp += number;
    setTotalCount(temp);
  };
  useEffect(() => {
    execute({ order_id: orderId }).then((result) => {
      let temp = [];
      let countFinal = 0;

      temp = result.orders.map((value) => {
        return {
          ...value,
          order_items: value.order_items.map((val) => {
            let oop = JSON.parse(val.OptionOrderItem);
            let countTotal = parseInt(val.count);
            console.log("test", val);
            JSON.parse(val?.OptionOrderItem)?.map((v) => {
              console.log("object", v);
              if (v?.value[0]?.value?.priceOnOrder != 0) {
                countTotal += 1;
              }
              if (v?.value[0]?.value?.pricePerUnit != 0) {
                countTotal += parseInt(val.count);
              }
            });
            // oop.map((x) => {
            //   if (x.value[0]?.value?.priceOnOrder != 0) countTotal += 1;
            //   if (x.value[0]?.value?.pricePerUnit != 0)
            //     countTotal += parseInt(val.count);
            // });
            countFinal += countTotal;

            return { ...val, OptionOrderItem: oop };
          }),
        };
      });

      // for (let i = 0; i < temp.length; i++) {
      //   countFinal += parseInt(temp[i].count);
      // }
      console.log("val", countFinal);
      setTotalCount(countFinal);
      setFactorList(...temp);
    });
    executeFabric().then((result) => {
      setFabricList(result);
    });
  }, []);
  return (
    <div className="m-3">
      <div className=" mb-2 mt-4 border p-3 rounded-2 d-flex flex-wrap justify-content-between">
        <p>
          <span className="fw-bold">شرکت:</span>&nbsp;{" "}
          <span style={{ lineHeight: 1.5 }}>
            {factorList?.customer?.corporate == "1"
              ? `${factorList?.customer?.company_name}(${factorList?.customer?.firstname} ${factorList?.customer?.lastname})`
              : `${factorList?.customer?.firstname} ${factorList?.customer?.lastname}`}
          </span>
        </p>
        <p>
          <span className="fw-bold">توسط:</span>&nbsp;
          <span>{factorList?.customer?.main_uid?.fullname}</span>
        </p>
        <p>
          <span className="fw-bold">تاریخ:</span>&nbsp;
          <span>{TimeStampToJalali(factorList.mtm * 1000)} </span>
        </p>
      </div>
      {console.log("factorList?.order_items", factorList?.order_items)}
      <FactorTable
        factorList={factorList?.order_items}
        fabricList={fabricList}
      />
      <div>
        <div style={{ width: 300 }} className="ms-auto ">
          <div className="d-flex align-items-center">
            {" "}
            <p className=" ">تعداد</p> &nbsp;
            <div className="  border p-2  rounded-2 ms-auto">
              <p style={{ width: 200 }}>{totalCount} عدد</p>
            </div>
          </div>
          <div className="d-flex align-items-center my-1">
            {" "}
            <p className=" ">تخفیف کل</p> &nbsp;
            <div className="  border p-2 rounded-2  ms-auto">
              <p style={{ width: 200 }}>{addCommas(factorList?.discount)}</p>
            </div>
          </div>
          <div className="d-flex align-items-center my-1">
            {" "}
            <p className=" ">جمع کل</p> &nbsp;
            <div className="  border p-2 rounded-2  ms-auto">
              <p style={{ width: 200 }}>
                {addCommas(factorList?.total_amount)}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
